import { addTrailingSlash } from "@draftkings/sportsbook-common-utils";
export function composeUrl(apiUrlConfig) {
    const apiUrl = [apiUrlConfig.baseUrl, apiUrlConfig.version, apiUrlConfig.service]
        .reduce((url, slug) => url.concat(addTrailingSlash(slug)), "");
    return apiUrl;
}
export function composeSdApiUrl(endpoint, apiUrlConfig) {
    const apiUrl = [apiUrlConfig.baseUrl, apiUrlConfig.service, apiUrlConfig.version,]
        .reduce((url, slug) => url.concat(addTrailingSlash(slug)), "");
    return `${apiUrl}${endpoint}`;
}
//# sourceMappingURL=composeUrl.js.map